module.exports = __webpack_public_path__ + "img/misson_vision_value_01_2.b06104d4.jpg";